var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"img",on:{"click":function($event){_vm.pack = !_vm.pack}}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,attrs:{"src":_vm.src,"page":i}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a56bba3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = null
// module chunks = 